import { Button, Flex, Table, Tag, Form, Select, Input, Col, Row } from "antd";
import React, { useState } from "react";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { colors } from "../../../../../constants/colors";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Spinner from "../../../../common/spinner/Spinner";
import { appConstConfig } from "../../../../../constants/config/appConstConfig";
import {
  getServiceProviderServicesAction,
  getStaffMemberByServiceProviderIdAction,
  updateOrganizationServicesStatusAction,
} from "../../../../../redux/services/service-providers/serviceProvidersServices";
import { dateObjToDispViewDate, getStatusNameInArabicAsWell } from "../../../../../utils/utils";
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import styles from "./ServiceProvider.module.scss";
import useDebounce from "../../../../../hooks/useDebounce";

const ServiceProviderDetailsStaff = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* id dependencies */
  const { serviceProviderServices } = useSelector(
    (state) => state.serviceProviders
  );

  const {
    selectedServiceProvider: { selectedServiceProviderId, navigateBack },
    staffMembersList,
  } = useSelector((state) => state.serviceProviders);
  /* id dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: serviceProviderServices?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  const { debouncedValue: debouncedSearchValue, debounceLoading } = useDebounce(
    searchValue,
    500
  );
  /* table dependencies */

  useEffect(() => {
    handleGetTableData();
  }, [pagination, debouncedSearchValue]);

  const handleGetTableData = () => {
    /* initial dependencies - Edit */
    if (
      selectedServiceProviderId &&
      selectedServiceProviderId !== "" &&
      selectedServiceProviderId !== null &&
      selectedServiceProviderId !== undefined
    ) {
      const dataToBeSent = {
        page: pagination?.pageNo,
        limit: pagination?.pageSize,
        selectedServiceProviderId: selectedServiceProviderId,
        search: debouncedSearchValue,
      };
      setLoading(true);
      dispatch(
        getStaffMemberByServiceProviderIdAction(dataToBeSent, setLoading)
      );
    }
    /* initial dependencies - Edit */
  };

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("Modules.Provider.ID"),
        dataIndex: "id_number",
        key: "id_number",
        render: (_, record) =>
          record?.id_number ?? "S-" + record?.staff_number,
        width:'120px'
      },
      {
        title: t("Modules.Configuration.userType"),
        dataIndex: "role",
        key: "role",
      },
      {
        title: t("chats.userName"),
        render: (_, record) =>
          record?.first_name || record?.first_name
            ? `${record?.first_name} ${record?.last_name}`
            : "-",
      },
      {
        title: t("chats.userEmail"),
        render: (_, record) => (record?.email ? `${record?.email}` : "-"),
      },
      {
        title: t("CommonUtils.category"),
        render: (_, record) =>
          record?.categoryInfo?.category?.name
            ? `${record?.categoryInfo?.category?.name}`
            : "-",
      },

      {
        title: t("CommonUtils.subCategory"),
        render: (_, record) => {
          return (
            <Flex gap="small" justify="left" style={{ flexWrap: "wrap" }}>
              {record?.categoryInfo?.subcategories?.map((subcategory, index) => (
                <Tag key={index}>{subcategory.name}</Tag>
              ))}
            </Flex>
          );
        },
      },

      {
        title: t("Modules.Provider.dateofJoining"),
        dataIndex: "created_at",
        key: "created_at",
        render: (_, record) => (
          <p>{dateObjToDispViewDate(record?.created_at, "ddmmyyyy")}</p>
        ),
      },
      {
        title: t("Modules.AutoCredit.status"),
        key: "action",
        align: "center",
        render: (_, record) => {
          const getColorBasedOnStatus = (status) => {
            switch (status) {
              case "active":
                return { background: colors.lightTeal, color: colors.darkTeal };

              case "inactive":
                return {
                  background: colors.lightPinkishRed,
                  color: colors.darkMaroon,
                };

              case "suspended":
                return {
                  background: colors.lightPinkishRed,
                  color: colors.darkMaroon,
                };

              case "deleted":
                return {
                  background: colors.lightPinkishRed,
                  color: colors.darkMaroon,
                };

              default:
                break;
            }
          };
          return (
            <>
              <Tag
                bordered={false}
                style={{
                  ...getColorBasedOnStatus(record?.status),
                  textTransform: "capitalize",
                }}
              >
                {getStatusNameInArabicAsWell(String(record?.status))}
              </Tag>
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  return (
    <div className="servicesListContainer">
      <Flex vertical gap="2rem">
        <Flex gap="1rem" align="center">
          <Button
            type="default"
            shape="circle"
            size="small"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(navigateBack)}
          />
          <Input
            size="large"
            suffix={<SearchOutlined />}
            placeholder={t("Modules.customer.search")}
            onChange={(event) => setSearchValue(event.target.value)}
            style={{ width: "370px" }}
          />
        </Flex>
        {loading || debounceLoading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={staffMembersList?.data}
            columns={columns}
            pagination={paginationObj}
          />
        )}
      </Flex>
    </div>
  );
};

export default ServiceProviderDetailsStaff;
